<template>
  <div class="m-list">
    <div class="width-a">
      <h1 class="title">自定义数据</h1>
      <ul class="type">
        <template v-for="(item, index) in types">
          <li :class="typeIndex == item.typeId ? 'type-b' : 'type-a'" :key="item.typeId" @click="typeTap(item.typeId)">{{item.typeName}}</li>
        </template>
      </ul>
      <ul class="content">
        <li class="toolsb">
          <el-input class="mb-input" placeholder="请输入标题" v-model="customizeTitle"></el-input>
          <el-button type="primary" @click="toQuery">搜索</el-button>
          <el-button type="primary" @click="resetQuery">重置</el-button>
        </li>
        <template v-for="(item, index) in tableData">
          <li class="c-item" :key="item.customizeId" style="cursor: pointer" @click="detailTap(index)">
            <div class="left">
              <img v-if="item.imageUrl" :src="item.imageUrl | fileFilter" alt="">
              <img v-else :src="require('@/assets/default.png')" alt="">
            </div>
            <div class="right">
              <h2 class="ci-title">{{item.customizeTitle}}</h2>
              <div class="ci-info">
                <span>{{item.publishTime}}</span>
              </div>
            </div>
          </li>
        </template>
      </ul>
      <el-pagination class="ma-pagination" :current-page="curPage" layout="total, prev, pager, next" :total="total" @current-change="handleCurrentChange"></el-pagination>
    </div>
  </div>
</template>

<script>
import HttpConnectionC from "@/utils/HttpConnectionC";
import CommonFilters from "@/mixins/CommonFilters";
export default {
  name: "News",
  mixins: [CommonFilters],
  data () {
    return {
      customizeTitle: "",
      tableData: [],
      types: [],
      typeIndex: 0,
      curPage: 1,
      total: 0
    };
  },
  mounted () {
    let that = this;
    that.typeIndex = that.$route.query.typeId;
    HttpConnectionC.get("homepage/listCustomizeType").then(function (response) {
      that.types = response.data;
      that.queryData();
    });
  },
  methods: {
    queryData () {
      let that = this;
      // let _typeId = that.types[that.typeIndex].typeId;
      HttpConnectionC.get("/homepage/listCustomize", {
        params: {
          customizeTitle: that.customizeTitle,
          typeId: that.typeIndex,
          pageNum: that.curPage,
          pageSize: 10,
          state: 1,
        }
      }).then(function (response) {
        that.tableData = response.rows;
        that.total = response.total;
      });
    },
    typeTap (index) {
      this.typeIndex = index;
      this.queryData();
    },
    handleCurrentChange (val) {
      this.curPage = val;
      this.queryData();
    },
    detailTap (index) {
      let _id = this.tableData[index].customizeId;
      console.log(_id)
      this.$router.push({
        path: "/CustomizeDetail?customizeId=" + _id
      });
    },
    toQuery () {
      this.curPage = 1;
      this.queryData();
    },
    resetQuery () {
      this.customizeTitle = "";
      this.curPage = 1;
      this.queryData();
    }
  }
};
</script>

<style scoped lang="scss">
.m-list {
  background-image: url("../assets/bga01.png");
  background-repeat: no-repeat;
}
.title {
  font-size: 36px;
  font-weight: normal;
  color: #ffffff;
  text-align: center;
  padding: 60px 0px 40px 0px;
}
.type {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  .type-a {
    width: 140px;
    height: 46px;
    text-align: center;
    line-height: 46px;
    background-color: #395bcd;
    color: #ffffff;
    font-size: 16px;
    margin: 0px 16px;
    cursor: pointer;
  }
  .type-b {
    width: 140px;
    height: 46px;
    text-align: center;
    line-height: 46px;
    background-color: #253b85;
    color: #ffffff;
    font-size: 16px;
    margin: 0px 16px;
    cursor: pointer;
  }
}
.content {
  padding: 60px 60px 0px 60px;
  margin-top: 60px;
  background-color: #ffffff;
}
.c-item {
  display: flex;
  flex-direction: row;
  padding: 32px;
  border: solid 1px #e3e4e5;
  margin: 0px 0px 30px 0px;
}
.left {
  width: 240px;
  height: 160px;
  display: flex;
  justify-content: center;
  align-items: center;
  img {
    width: auto;
    height: auto;
    max-width: 100%;
    max-height: 100%;
  }
}
.right {
  flex: 1;
  padding: 10px 40px 10px 40px;
}
.ci-title {
  height: 110px;
  font-size: 20px;
  color: #333333;
  font-weight: normal;
}
.ci-info {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  color: #999999;
  font-size: 18px;
}
</style>
